import React from 'react';
import MyAccountOverview from '../components/MyAccountOverview';
import { UserProfileData } from "../util/UserAccount";
import { ITherapistPlan } from "../util/types";

type Props = { userProfile: UserProfileData, plans: ITherapistPlan[] };

const MyAccountOverviewContainer = ({ userProfile, plans }: Props) => {
  return (<MyAccountOverview userProfile={userProfile} plans={plans} />)
};

export default MyAccountOverviewContainer;
